import Link from "next/link";
import React from "react";
import { useArticles } from "src/services/FeaturedContent";
import { renderRichText } from "src/services/PrismicService";
import { getArticleAsUrl } from "src/services/UrlService";
import styles from "./styles.scss";

import XSMALL_PLACEHOLDER from "public/article/xsmall.jpg";

const NewsletterArticles = () => {
  const featuredContentList = useArticles();

  return (
    <section className="newsletter-articles">
      <div className="articles-container">
        <h2 className="header-title">Still unsure? See for yourself</h2>
        <div className="articles">
          {featuredContentList.slice(0, 4).map((article: any) => (
            <div className="article" key={article._meta.uid}>
              <img className="article-image" src={XSMALL_PLACEHOLDER} alt={article.seo_title} />
              <div className="article-title">{renderRichText(article.title)}</div>
              <div className="article-description">
                <p className="article-text">{article.description}</p>
                <Link href={getArticleAsUrl(article)} legacyBehavior>
                  <a className="article-link">See Now</a>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style jsx>{styles}</style>
    </section>
  );
};

export default NewsletterArticles;
